import css from './index.module.scss';
import NotRecommended from './NotRecommended';
import NeedFurtherEvaluation from './NeedFurtherEvaluation';
import Recommended from './Recommended';
import { useGlobal } from '@/utils/useGlobal';

export default function CalculatorResult({ result, id }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('bladecalculator');
    return (
        <div className={`calculator-result ${css.calculatorResult}`}>
            <p className="result-common-title">{t('detail.calculator_result_title')}</p>
            {result === 1 && <NotRecommended id={id} />}
            {result === 2 && <NeedFurtherEvaluation id={id} />}
            {result === 3 && <Recommended />}
        </div>
    );
}
